import { INPUT_PARAM_DEFAULTS } from './constants';

export const parseInputParameters = values => ({
	vinMin: parseFloat(values.vinMin),
	vinMax: parseFloat(values.vinMax),

	vout: parseFloat(values.vout),
	iout: parseFloat(values.iout),
	ambientTemperature: parseFloat(values.ambientTemperature),
	supplyType: values.supplyType,
	lineFrequency: parseInt(values.lineFrequency),
	isolated: values.isolated
});

export const checkForChanges = values => parseFloat(values.ambientTemperature) === INPUT_PARAM_DEFAULTS.AMB_TEMP;
